module.exports = __webpack_public_path__ + "static/media/Overhead.15d1a79e.svg";